import { apis } from "../constants";
import { request } from "../utils";

export const getOrgAlarms = (orgId: any) => {
    return request<OrgAlarm[]>(apis.getOrgAlarms, { params: { orgId }, method: 'get' })
}
export const getProjectAlarms = (projectId: any) => {
    return request<OrgAlarm[]>(apis.getProjectAlarms, { params: { projectId }, method: 'get' })
}
export const getOrgAlarmTypes = (orgId: any) => {
    return request<OrgAlarmType>(apis.getOrgAlarmTypes, { params: { orgId }, method: 'get' })
}
export const getProjectAlarmTypes = (projectId: any) => {
    return request<OrgAlarmType>(apis.getProjectAlarmTypes, { params: { projectId }, method: 'get' })
}
export const getOrgRealtimeData = (orgId: any) => {
    return request<RealtimeData[]>(apis.getOrgRealtimeData, { params: { orgId }, method: 'get' })
}
export const getProjectRealtimeData = (projectId: any) => {
    return request<RealtimeData[]>(apis.getProjectRealtimeData, { params: { projectId }, method: 'get' })
}

export const getOrgReportV2Summary = (orgId: any) => {
    return request<OrgReportV2Summary>(apis.getOrgReportV2Summary, { params: { orgId }, method: 'get' })
}

export const getProjectReportV2 = (projectId: any) => {
    return request<ProjectReportDto>(apis.getProjectReportV2, { params: { projectId }, method: 'get' })
}

export const getOrgReport = async (orgId: any) => {
    const summary = await getOrgReportV2Summary(orgId)
    const projectIds = summary.projectIdList || []

    if (!projectIds.length) {
        return {
            organizationId: summary.organizationId,
            totalAlarmCnt: summary.totalAlarmCnt,
            totalDeviceCnt: summary.totalDeviceCnt,
            totalOffline: summary.totalOffline,
            totalOnline: summary.totalOnline,
            projectReportInfoList: [],
        } as OrgReport
    }

    const projectResults = await Promise.allSettled(projectIds.map(projectId => getProjectReportV2(projectId)))
    const projectReportInfoList: ProjectReportInfo[] = projectResults
        .filter((result): result is PromiseFulfilledResult<ProjectReportDto> => result.status === 'fulfilled')
        .map(result => ({
            ...result.value,
        }))

    return {
        organizationId: summary.organizationId,
        totalAlarmCnt: summary.totalAlarmCnt,
        totalDeviceCnt: summary.totalDeviceCnt,
        totalOffline: summary.totalOffline,
        totalOnline: summary.totalOnline,
        projectReportInfoList,
    } as OrgReport
}

export const getOrgOnlineRatio = (orgId: any, frequency: any) => {
    return request<OrgOnlineRatioStatistics>(apis.getOrgRealtimeOnlineRatio, { params: { orgId, frequency }, method: 'get' })
}

export const getProjectOnlineRatio = (projectId: any, frequency: any) => {
    return request<ProjectOnlineRatioStatistics>(apis.getProjectRealtimeOnlineRatio, { params: { projectId, frequency }, method: 'get' })
}


